import { useState } from 'react';

// material-ui
import { Grid, MenuItem, TextField, Typography } from '@mui/material';
import SkeletonTotalGrowthBarChart from '../Skeleton/TotalGrowthBarChart';
import TotalGrowthBarChart from './TotalGrowthBarChart.client';

// types
import PropTypes from 'prop-types';
import MainCard from "../MainCard";
import {gridSpacing} from "../../../store/constants";

const status = [
    {
        value: 'today',
        label: 'Today'
    },
    {
        value: 'month',
        label: 'This Month'
    },
    {
        value: 'year',
        label: 'This Year'
    }
];

// ==============================|| DASHBOARD - CHART CARD ||============================== //

const TotalGrowthBarCard = ({ isLoading, subCountiesData }) => {
    const [value, setValue] = useState('today');

    return (
        <>
            {isLoading ? (
                <SkeletonTotalGrowthBarChart />
            ) : (
                <MainCard>
                    <Grid container spacing={gridSpacing}>
                        {/* <Grid item xs={12}>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid item>
                                    <Grid container direction="column" spacing={1}>
                                        <Grid item>
                                            <Typography variant="subtitle2">Total Income</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h3">Kes 2,324.00</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <TextField
                                        id="standard-select-currency"
                                        select
                                        value={value}
                                        onChange={(e) => setValue(e.target.value)}
                                    >
                                        {status.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>
                        </Grid> */}
                        <Grid item xs={12}>
                            <TotalGrowthBarChart isLoading={isLoading} subCountiesData={subCountiesData} />
                        </Grid>
                    </Grid>
                </MainCard>
            )}
        </>
    );
};

TotalGrowthBarCard.propTypes = {
    isLoading: PropTypes.bool
};

export default TotalGrowthBarCard;